import { Link, getMenuNavItems, type Locale } from "@/i18n/routing";

interface PublicFooterProps {
  locale: Locale;
}

export function PublicFooter({ locale }: PublicFooterProps) {
  const footerNavItems = getMenuNavItems("footer");
  return (
    <footer className="relative z-10 border-t border-[var(--border-gold)] bg-[var(--bg-header)] p-5 text-center mt-auto">
      {footerNavItems.length > 0 && (
        <nav className="mb-4">
          <ul className="flex flex-wrap justify-center gap-4">
            {footerNavItems.map((item) => (
              <li key={item.pathnames[locale]}>
                <Link
                  href={item.pathnames[locale]}
                  className="font-cinzel text-muted text-[0.85rem] tracking-[0.08em] hover:text-foreground transition-colors"
                >
                  {item.label[locale]}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      )}
      <p className="font-cinzel text-muted text-[0.85rem] tracking-[0.08em]">
        Mikamika Oy
      </p>
      <div className="safe-area-bottom h-[env(safe-area-inset-bottom,0)]" />
    </footer>
  );
}
